import { apiGet, apiPost } from './client';
import {
  CompleteLoginRequest,
  CompleteLoginResponse,
  MeResponse,
  VerifyCredentialsRequest,
  VerifyCredentialsResponse,
} from '../types/auth';

export function verifyCredentials(
  req: VerifyCredentialsRequest,
): Promise<VerifyCredentialsResponse> {
  return apiPost<VerifyCredentialsRequest, VerifyCredentialsResponse>(
    '/api/auth/verify-credentials',
    req,
  );
}

export function completeLogin(
  req: CompleteLoginRequest,
): Promise<CompleteLoginResponse> {
  return apiPost<CompleteLoginRequest, CompleteLoginResponse>(
    '/api/auth/complete-login',
    req,
  );
}

export function getMe(): Promise<MeResponse> {
  return apiGet<MeResponse>('/api/auth/me');
}

export async function logout(): Promise<void> {
  await apiPost<undefined, unknown>('/api/auth/logout');
}
